export default function BottomCTA() {
  const openConsultationDrawer = () => {
    const drawer = document.getElementById('consultation-drawer');
    if (drawer) {
      drawer.classList.remove('translate-x-full');
    }
  };

  const handleViewPricing = () => {
    window.REACT_APP_NAVIGATE('/capabilities');
  };

  const openExampleModal = () => {
    const modal = document.getElementById('example-modal');
    if (modal) {
      modal.classList.remove('hidden');
    }
  };

  return (
    <section className="py-24 bg-gradient-to-br from-[#14B8A6] to-[#0D9488]">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="text-center">
          <h2 className="text-4xl font-bold text-white mb-4">
            获取定制化合规管理方案
          </h2>
          <p className="text-white/90 text-lg mb-10 max-w-2xl mx-auto">
            无论您是跨境电商卖家、外贸公司还是市场商户，我们都能为您提供专业的合规管理解决方案
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={openConsultationDrawer}
              className="inline-flex items-center gap-2 px-10 h-14 bg-white text-[#14B8A6] font-semibold rounded-full hover:bg-gray-50 transition-all whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl text-base"
            >
              提交需求
              <i className="ri-arrow-right-line text-lg"></i>
            </button>

            <button
              onClick={handleViewPricing}
              className="inline-flex items-center gap-2 px-10 h-14 bg-white/10 border-2 border-white text-white font-semibold rounded-full hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer text-base backdrop-blur-sm"
            >
              查看产品及价格
              <i className="ri-price-tag-3-line text-lg"></i>
            </button>

            <button
              onClick={openExampleModal}
              className="inline-flex items-center gap-2 text-white font-medium hover:text-white/80 transition-colors cursor-pointer text-base underline underline-offset-4"
            >
              先跑通一票（9.9/99）
              <i className="ri-arrow-right-up-line text-lg"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}